import { EstadosPreagendamientoEnumChoice, ModulosEnumChoice, a11yProps, sizeTab, texto, useCheckPermissions } from "@/shared";
import { Box, Tab, Tabs } from "@mui/material";
import { useEffect, useState } from "react";
import { SingleTableBoxScene } from "@/shared/components/ui";
import { PermissionsEnum } from "@/auth/interfaces";
import { useDiccionarioMotivo } from "@/store/erp/diccionario_motivo/diccionario_motivo.store";
import { CustomTabPanel } from "@/erp/sale";
import TablePreAgendamientoPymes from "../../shared/componente/table_preagendamiento_pymes/TablePreAgendamientoPymes";

const PreAgendamientosPymesPage = () => {

  useCheckPermissions(PermissionsEnum.api_view_preagendamientopymes);

  // Obtener username y rol del estado global

  //STATE
  const [valueTab, setValueTab] = useState(0);
  const setFaseVenta = useDiccionarioMotivo().setFaseVenta

  useEffect(() => {
    setFaseVenta(ModulosEnumChoice.PREAGENDAMIENTO);
  }, [])


  return (
    <SingleTableBoxScene
      title={"Preagendadas PYMES"}
      py={2}
    >
      <Box sx={{ bgcolor: 'background.paper', maxWidth: sizeTab, paddingBottom: 2 }} >
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Tabs
            value={valueTab}
            onChange={(_event: React.SyntheticEvent, newValue: number) => {
              setValueTab(newValue);
            }}
            variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile
            aria-label="scrollable force tabs preagendamiento"
          >
            <Tab label={'Preagendadas'} {...a11yProps(0)} />
            <Tab label={'Finalizadas'} {...a11yProps(1)} />
            <Tab label={texto.cancelado} {...a11yProps(2)} />
          </Tabs>

        </Box>
      </Box>

      <CustomTabPanel value={valueTab} index={0}>
        <TablePreAgendamientoPymes
          estado_preagendamiento={EstadosPreagendamientoEnumChoice.EN_ESPERA}
        />
      </CustomTabPanel>
      <CustomTabPanel value={valueTab} index={1}>
        <TablePreAgendamientoPymes
          estado_preagendamiento={EstadosPreagendamientoEnumChoice.FINALIZADO}
          enable_actions={false}

        />
      </CustomTabPanel>
      <CustomTabPanel value={valueTab} index={2}>
        <TablePreAgendamientoPymes
          estado_preagendamiento={EstadosPreagendamientoEnumChoice.CANCELADO}
          enable_actions={false}
        />
      </CustomTabPanel>


    </SingleTableBoxScene>
  );
}

export default PreAgendamientosPymesPage;